export default "__VITE_ASSET__d4kpfdmJ__"